









import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DadosNome extends Vue {
    get nome () {
        return this.$store.state.cotacao.nome;
    }

    set nome ( value ) {
        this.$store.commit("SET_NOME", value);
    }

    get errorNome () {
        return this.$store.state.errors.nome;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
